import { Card, CardBody, CardHeader, Button, Alert, Spinner } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { ObjectTable } from './GenericOverview';
import {
  useSpamOverview, useA11yOverview, useScanOverview, useSearchOverview,
} from './useProductApis';

/**
 * #282 — Operator-Read-only-Sichten für spam/a11y/scan/search. Backend + BFF waren
 * bereits gebaut; hier die fehlenden Orbit-Seiten (generischer Overview-Renderer,
 * da das BFF das Upstream-JSON roh durchreicht).
 */
function ProductShell({ title, subtitle, query, children }) {
  return (
    <div>
      <PageHeader title={title} subtitle={subtitle} />
      <div className="d-flex justify-content-end mb-2">
        <Button size="sm" color="secondary" outline disabled={query.isFetching} onClick={() => query.refetch()}>
          {query.isFetching ? 'Aktualisiere…' : 'Aktualisieren'}
        </Button>
      </div>
      {query.isLoading ? (
        <div className="p-4 text-center"><Spinner size="sm" /> Lade…</div>
      ) : query.isError ? (
        <Alert color="danger" className="small">Konnte Daten nicht laden: {String(query.error?.message || query.error)}</Alert>
      ) : query.data?.available === false ? (
        <Alert color="secondary" className="small">Dienst ist nicht konfiguriert (dormant).</Alert>
      ) : (
        children
      )}
    </div>
  );
}

// Einfacher Fall (a11y/scan/search): { available, overview } | { available, error }.
function SimpleOverview({ title, subtitle, query }) {
  const d = query.data || {};
  return (
    <ProductShell title={title} subtitle={subtitle} query={query}>
      {d.error ? (
        <Alert color="warning" className="small">Upstream-Fehler: {String(d.error)}</Alert>
      ) : (
        <Card><CardBody><ObjectTable obj={d.overview || {}} /></CardBody></Card>
      )}
    </ProductShell>
  );
}

export function A11yApiPage() {
  return <SimpleOverview title="Barrierefreiheit-API" subtitle="Operator-Übersicht (#282) — a11y-api" query={useA11yOverview()} />;
}
export function ScanApiPage() {
  return <SimpleOverview title="Scan-API" subtitle="Operator-Übersicht (#282) — scan-api" query={useScanOverview()} />;
}
export function SearchApiPage() {
  return <SimpleOverview title="Such-API" subtitle="Operator-Übersicht (#282) — search-api" query={useSearchOverview()} />;
}

// Spam aggregiert selbst 3 Teile (monitoring/phishing/blocklist) + errors.
export function SpamApiPage() {
  const query = useSpamOverview();
  const d = query.data || {};
  const parts = [
    ['Monitoring', d.monitoring],
    ['Phishing', d.phishing],
    ['Blocklist', d.blocklist],
  ];
  return (
    <ProductShell title="Spam-/Phishing-API" subtitle="Operator-Übersicht (#282) — spam-api" query={query}>
      {Array.isArray(d.errors) && d.errors.length > 0 && (
        <Alert color="warning" className="small">
          Teil-Fehler: {d.errors.map((e) => `${e.part}: ${e.error}`).join(' · ')}
        </Alert>
      )}
      <div className="row g-3">
        {parts.map(([label, obj]) => (
          <div className="col-md-4" key={label}>
            <Card className="h-100">
              <CardHeader className="py-2 small fw-semibold">{label}</CardHeader>
              <CardBody>{obj ? <ObjectTable obj={obj} /> : <span className="text-muted small">nicht verfügbar</span>}</CardBody>
            </Card>
          </div>
        ))}
      </div>
    </ProductShell>
  );
}
